/*
 * @Author: your name
 * @Date: 2022-02-26 13:43:24
 * @LastEditTime: 2022-03-23 11:17:22
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \kares_pad\src\i18n\language\index.js
 */
import custom_en from './en-US' // 英文
import custom_zh from './zh-CN' // 中文
import custom_vi from './vi' // 越南语

import el_en from 'element-ui/lib/locale/lang/en'
import el_zh from 'element-ui/lib/locale/lang/zh-CN'
import el_vi from 'element-ui/lib/locale/lang/vi'

export default {
  en: {
    ...custom_en,
    ...el_en
  },
  zh: {
    ...custom_zh,
    ...el_zh
  },
  vi: {
    ...custom_vi,
    ...el_vi
  }
}